import React from "react"
import { FILE_TYPES } from "./constants"

/**
 * @typedef {Object} StagedFile
 * @property {string} filename - Original filename
 * @property {File} file - The actual File object for upload
 */

/**
 * @typedef {Object} UploadedFilesListProps
 * @property {Object.<string, StagedFile|null>} files - Map of file type to staged file info
 * @property {(fileType: string) => void} onDelete - Callback when delete button is clicked
 */

/**
 * Displays list of staged file cards with delete buttons.
 *
 * @param {UploadedFilesListProps} props - Component props
 * @returns {React.ReactElement} The file list component
 */
export function UploadedFilesList({ files, onDelete }) {
  const uploadedFiles = Object.entries(files)
    .filter(([_, file]) => file !== null)
    .map(([typeKey, file]) => ({
      typeKey,
      file,
      typeInfo: Object.values(FILE_TYPES).find(t => t.key === typeKey)
    }))

  if (uploadedFiles.length === 0) {
    return null
  }

  return (
    <div className="zone-upload-files-list">
      <h4 className="zone-upload-files-list__title">Selected Files</h4>
      <div className="zone-upload-files-list__items">
        {uploadedFiles.map(({ typeKey, file, typeInfo }) => (
          <div key={typeKey} className="zone-upload-file-card">
            <div className="zone-upload-file-card__info">
              <span className="zone-upload-file-card__filename">{file.filename}</span>
              <span className="zone-upload-file-card__type">{typeInfo?.label}</span>
            </div>
            <button
              data-testid={`delete-${typeKey}`}
              className="zone-upload-file-card__delete"
              onClick={() => onDelete(typeKey)}
              aria-label={`Delete ${file.filename}`}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
